import { createSlice } from "@reduxjs/toolkit";
import { CampaignInsightsSlice } from "types/campaign/insights";
import { fetchCampaignInsights } from "./thunk";

const initialState: CampaignInsightsSlice  = {
    loading: false,
    error: null,
    campaigns: {}
}

const campaignInsightsSlice = createSlice({
    name: 'campaignInsights',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchCampaignInsights.pending, (state) => {
            state.loading = true;
            state.error = null;
        })

        .addCase(fetchCampaignInsights.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.error = null;

            const {campaignInsights, campaignId} = payload;
            state.campaigns[campaignId] = {
                ...campaignInsights,
                last_fetched_at: Date.now(),
                expired: false
            };
        })
        .addCase(fetchCampaignInsights.rejected, (state, {payload}) => {
            state.loading = false;
            state.error = payload || "Failed to fetch campaign insights!";
        })
    }
})

export default campaignInsightsSlice.reducer;